angular.module('unica_invitation_list.invitation_list_controllers')

.controller('InvitationListComunicateDemDeclinedController',
	function(
		$rootScope, $scope, $state, $stateParams, $timeout, $filter,
		$confirm,
		InvitationListComunicateService
	) {

	$scope.id              = $stateParams.id;
	$scope.event_id        = $stateParams.event_id;


	$scope.tinymceOptionsReady = false;

	$scope.tinymceOptionsEmailSubjectDem = angular.copy($rootScope.tinymceOptionsEmailSubject);
	$scope.tinymceOptionsEmailBodyDem = angular.copy($rootScope.tinymceOptionsEmailBody);

	$rootScope.getInvitationList($stateParams.id);

	$rootScope.getServicesUsers();

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.getEventTags( $stateParams.event_id );

	$scope.$on( 'event_tag_loaded', function() {

		var tinymceValues = [
			{ text: 'Nome', value: '{FIRST_NAME}' },
			{ text: 'Cognome', value: '{LAST_NAME}' },
			{ text: 'Data Tappa Da', value: '{FIRST_STAGE_DAY_FROM}' },
			{ text: 'Data Tappa A', value: '{FIRST_STAGE_DAY_TO}' },
			{ text: 'Orario Tappa Da', value: '{FIRST_STAGE_TIME_FROM}' },
			{ text: 'Orario Tappa A', value: '{FIRST_STAGE_TIME_TO}' },
			{ text: 'Nome Location', value: '{LOCATION_NAME}' },
			{ text: 'Indirizzo Location', value: '{LOCATION_ADDRESS}' },
			{ text: 'Nome Agenzia', value: '{AGENCY_NAME}' },
		];

		angular.forEach($rootScope.eventTagData, function(tag, key) {
			if ( tag.type === 'text' ) {
				var value = tag.tag.toLowerCase();
				value = value.replace(' ', '_');
				value = value.replace('à', 'a');
				value = value.replace('è', 'e');
				value = value.replace('é', 'e');
				value = value.replace('ì', 'i');
				value = value.replace('ò', 'o');
				value = value.replace('ù', 'u');
				value = value.replace(/[^a-zA-Z0-9]/g,'_');
				value = value.toUpperCase();
				tinymceValues.push( { text: tag.tag, value: '{' + value + '}' } )
			}
		});

		$scope.tinymceOptionsEmailSubjectDem.setup = function (editor) {
			editor.addButton('placeholder_btn', {
				type: 'listbox',
				text: 'Placeholders Email',
				icon: false,
				onselect: function (e) {
					editor.insertContent(this.value());
				},
				values: tinymceValues,
				onPostRender: function () {
				}
			});
		};

		$scope.tinymceOptionsEmailBodyDem.setup = function (editor) {
			editor.addButton('placeholder_btn', {
				type: 'listbox',
				text: 'Placeholders Email',
				icon: false,
				onselect: function (e) {
					editor.insertContent(this.value());
				},
				values: tinymceValues,
				onPostRender: function () {
				}
			});
		};


		$scope.tinymceOptionsReady = true;

	});


	$scope.checkDemDeclinedForm = function() {
		if ( !$scope.forms.dem_declined_form.$invalid &&
			 $rootScope.eventData ) {
			return false;
		}
		return true;
	};

	$scope.saveDemDeclined = function()
	{
		var eventData = angular.copy($rootScope.eventData);

		InvitationListComunicateService
			.updateDemDeclined(eventData)
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {

					$rootScope.eventData = data;

					$scope.showSuccessMsg('Comunicazione aggiornata con successo!', '');
				}

			});
	};



		/**
		 * FUNCTIONS FOR AUTOCOMPLETE USER FOR PREVIEW
		 */

		$scope.searchText = '';

		$scope.searchServiceUser = function(query) {
			return query ? $filter('filter')($rootScope.servicesUsers, {label: query}) : $rootScope.servicesUsers;
		};

		$scope.selectedServiceUser = function(service) {
			if ( service ) {
				$scope.previewDemData.user_id = service.id;
			} else {
				$scope.previewDemData.user_id = null;
			}
		};


	/**
	 * FUNCTIONS FOR PREVIEW FUNCTIONALITY
	 */
	$scope.previewDemData = {
		user_id: null
	};

	$scope.checkPreviewDemForm = function() {
		return ( !$scope.previewDemData.user_id ? true : false );
	};

	$scope.previewDemDeclined = function() {
		InvitationListComunicateService
			.previewDemDeclined( $rootScope.invitationListData.id, $scope.previewDemData.user_id )
			.then(function(data) {
				$rootScope.hideLoader();

				if ( data ) {
					$scope.showSuccessMsg('Anteprima inviata con successo!', '');
				}
			});
	};

});
